
import SearchComponent from "./index.vue";
import {PropType} from 'vue';
import {Category} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Category';
import CategorySearchService from 'modules/spravochnik/dt-front-page-generator/src/Search/CategorySearchService';

export default {
    components: {
        SearchComponent,
    },
    props: {
        categories: {
            type: Array as PropType<Array<Category>>,
        },
    },
    data() {
        return {
            service: new CategorySearchService(),
        }
    }
}
